import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';

import { env } from '../../config';

const ListArticleStats = () => {
  const [dateRange, setDateRange] = useState(null);
  const [lv, setLv] = useState('');
  const { t, i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  let filter = {};

  if (lv) filter.lv = lv;

  if (dateRange) filter = { ...filter, ...dateRange };

  return (
    <ListResource
      {...{
        searchable: true,
        api: '/api/quiz/assignments/stats',
        sort: { date: -1 },
        filter,
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: true,
        },
        cols: [
          {
            key: 'date',
            sortable: true,
            getter: (v) => (
              v ? moment(v).format('YYYY/MM/DD') : ''
            ),
          },
          { key: 'article.title', sortable: true, children: 'Title' },
          {
            key: 'lv',
            children: 'Group',
            getter: (v) => env.lvs[v][lang],
          },
          {
            key: 'answers._id',
            children: 'Grade',
            sortable: true,
            getter: (v) => env.grades[v][lang],
          },
          {
            key: 'maxScore',
            children: 'Article Score',
            getter: () => 60,
          },
          {
            key: 'answers.avgScore',
            children: 'Avg Score',
            sortable: true,
            getter: (v) => (Math.round(v * 100) / 100) || 0,
          },
          {
            key: 'answers.count',
            children: 'Answered Students',
            sortable: true,
            getter: (v, r) => (
              `${v || 0} / ${r.studentCount}`
            ),
          },
          {
            key: 'answers.countPct',
            children: '% of Answered Students',
            getter: (v, r) => (
              r.studentCount && r.answers
                ? `${
                  Math.round(((r.answers.count) / r.studentCount) * 10000)
                  / 100
                }%`
                : '0%'
            ),
          },
        ],
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={lv}
            onChange={(e) => setLv(e.target.value)}
          >
            <option value="">{t('Show All')}</option>
            {Object.keys(env.lvs).map((l) => (
              <option
                key={l}
                value={l}
              >{env.lvs[l][lang]}</option>
            ))}
          </select>,
        ],
      }}
    >
      {() => (
        <BtnDayRangePicker
          className="mr-2"
          value={dateRange}
          onChange={setDateRange}
          placeholder={t('Date')}
        />
      )}
    </ListResource>
  );
};

export default ListArticleStats;
